<template lang="pug">
  .termsContainer
    .termsContents
      h3 利用規約
      p これから以下に示すこれらの利用規約(利用契約・サービス契約)は、@smoooth666 が運営する ixa.tokyo (以下、IXA) とあなた(以下、ユーザー様)との関係を規定します。ユーザー様はこれらの用語に法的に拘束されるので、ユーザー様がこれを注意深く読むことは重要です。ユーザー様による IXA へのアクセス及び使用は、本利用規約へのあなたの同意および遵守に基づいています。本利用規約は、IXA にアクセスまたは使用するすべての訪問者、ユーザー、顧客、およびその他の者に適用されます。IXA にアクセスまたは使用することにより、ユーザー様は利用規約に拘束され、すべての法的結果を受け入れることに同意するものとします。ユーザー様が利用契約の諸条件の全部または一部に同意しない場合は、本サービスを使用しないでください。

      p IXA は以下のアプリケーションを含みます
      ul
        li Numbers3 当選予測番号ジェネレーター「<router-link to="/numbers3">Numbers 3</router-link>」
        li Numbers4 当選予測番号ジェネレーター「<router-link to="/numbers4">Numbers 4</router-link>」
        li LOTO 6 当選予測番号ジェネレーター「<router-link to="/loto6">Loto 6</router-link>」
        li LOTO 7 当選予測番号ジェネレーター「<router-link to="/loto7">Loto 7</router-link>」
        li 各種購入履歴「<router-link to="/ixa">History</router-link>」

      p これらから生成された、数列、文字列、確率がもたらす結果について、@smoooth666 は何ら責任を負わないものとします。

      .termsBody
        h4 IXA上で生成したデータについて
        p IXA上で生成したデータは、配布、共有してくださっても構いませんが、先に述べたとおり何ら責任を負わないものとします。 

      .termsBody
        h4 知的財産
        p IXAオリジナル以外のロゴを除き、IXA 上のテキスト、画像、グラフィック、コードを含むがこれらに限定されないすべてのコンテンツは @smoooth666 の所有物であり、著作権、商標、およびその他の知的所有権によって保護されています。ユーザー様は、ユーザー様自身の非営利目的での使用のためにのみ、本サービスの異なる領域からの資料の一部を表示し、コピー、ダウンロードまたは印刷することができます。その他の使用は固く禁じられており、著作権、商標およびその他の法律に違反する可能性があります。本利用規約は、@smoooth666 の商標を使用するためのライセンスをお客様に許諾するものではありません。ユーザー様はさらに、本サービスからダウンロードした資料からの所有権表示を使用、変更、削除しないことに同意します。 

      .termsBody
        h4 広告などによる他のWebサイトへのリンク
        p IXA には、@smoooth666 が所有または管理していない第三者のWebサイトまたはサービスへのリンクが含まれている場合があります。@smoooth666 は、第三者のWebサイトまたはサービスのコンテンツ、プライバシーポリシー、または慣行を管理することはなく、それらに対する責任も負いません。IXA で表示された他のWebサイトへの広告やリンクを出力するにあたり、以下のある状況について直接的または間接的に責任を負わないものとします。 

      .termsBody
        h4 サービス IXA の存続について 
        p IXA は回避不可能な自体に陥ったりするなどのなんらかの事故にあった場合、サービスを予告なく停止する可能性を含んでおります。本件に関して @smoooth666 は何ら責任を負わないものとします。 

      .termsBody
        h4 免責事項
        p 繰り返しになりますが、IXA の利用により生じた損失や損害などについては、いかなる場合も一切責任を負うものではありません。

      .termsBody
        p @smoooth666 : info@tris.work
</template>

<script>
export default {
  name: 'terms',
}
</script>

<style lang="stylus" scoped>
.termsContainer
  margin-top: 90px
  padding-bottom: 60px
  width: 100%
  .termsContents
    width: 90%
    margin: 20px auto
    h3
      font-weight: bolder
      line-height: 2em
    p
      font-size: 0.8rem
      line-height: 1.8em
      margin-bottom: 20px
      img
        display: block
        width: 70%
        margin: 20px auto
    ul
      margin: 16px 20px
      li
        font-size: 0.8rem
        line-height: 2.5em
    h4
      font-weight: bolder
      font-size: 0.9rem
      line-height: 2em
    .termsBody
      padding-bottom: 20px
</style>

